import { isContentMax, isMobile } from "components/utility/page-responsive/PageResponsive";
import { animateDonuts } from "./animateDonuts";
import { splitParagraph } from "./splitContentBlock";
import { animateInfographic, animateInfographicHeadline } from "./animatedInfoHeadline";
import { animatePremiums } from "./animatePremiums";

const chooseHandler = (entry) => {
	if (entry.target.classList.contains("ddiff-split-content")) {
		const splitContent = entry.target;
		if (entry.isIntersecting && isContentMax()) {
			splitParagraph(entry);
			animateInfographic(splitContent);
			animationDistanceObserver.unobserve(entry.target);
		} else if (entry.isIntersecting && !isContentMax()) {
			animationDistanceObserver.unobserve(entry.target);
		}
		if (entry.isIntersecting && !isMobile()) {
			animateInfographicHeadline(splitContent, true);
			animationDistanceObserver.unobserve(entry.target);
		}
		if (entry.isIntersecting && !isMobile()) {
			animatePremiums(entry);
			animationDistanceObserver.unobserve(entry.target);
		}
	}

	if (
		entry.target.classList.contains("animated-donuts") &&
		!entry.target.classList.contains("animated-donuts-static")
	) {
		if (entry.isIntersecting && !isMobile()) {
			animateDonuts(entry.target);
			animationDistanceObserver.unobserve(entry.target);
		}
	}
};

const animationDistanceObserver = new IntersectionObserver(
	(entries) =>
		entries.forEach((entry) => {
			chooseHandler(entry);
		}),
	{
		root: null,
		rootMargin: `0px 0px -25% 0px`,
		threshold: 0
	}
);

export const observeDistanceElements = () => {
	const distanceObservableElements = document.querySelectorAll(".ddiff-observable-distance");
	distanceObservableElements.forEach((element) => {
		if (element) {
			animationDistanceObserver.observe(element);
		}
	});
};
